<template>
  <div class="panel granary-panel">
    <div class="content">
      <div class="top-box">
        <div
          :class="activeIndex == i ? 'top-item active-item' : 'top-item'"
          v-for="(item, i) in list"
          :key="item.name"
        >
          <div class="item-left">
            <img :src="item.iconPath" class="item-icon" />
          </div>
          <div class="item-right">
            <div class="right-name">{{ item.name }}</div>
            <div class="right-bot">
              <span class="item-num">{{ item.total }}</span>
              <span class="item-unit">({{ item.unit }})</span>
            </div>
            <img
              src="~images/granary/nc/hjzzjz-title-bg.png"
              class="title-img"
            />
          </div>
        </div>
        <!-- <div class="area-title">各地区行政村数排行</div> -->
        <div class="area-title">
          “茂南、电白、信宜、高州、化州”行政村数排行
        </div>
        <div
          class="ranking-item flex"
          v-for="(it, index) in rankingList"
          :key="index"
        >
          <div class="ranking-left">
            <img :src="it.iconPath" />
          </div>
          <div class="ranking-right">
            <div class="ranking-right-top flex">
              <div class="city-name">{{ it.city }}</div>
              <div class="num-box">
                <span class="total-num">{{ it.totalNum }}</span>
                <span class="ranking-unit">（个）</span>
              </div>
            </div>
            <el-progress
              :percentage="handleProgressData(it.totalNum)"
              :show-text="false"
            ></el-progress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  data() {
    return {
      list: [
        {
          name: "行政村数",
          total: "1902",
          unit: "个",
          iconPath: require("@/assets/images/granary/nc/xzcs-icon.png")
        },
        {
          name: "自然村数",
          total: "20905",
          unit: "个",
          iconPath: require("@/assets/images/granary/nc/zrcs-icon.png")
        },
        {
          name: "美丽宜居村达标率",
          total: "62.04",
          unit: "%",
          iconPath: require("@/assets/images/granary/nc/xzcs-icon.png")
        },
        {
          name: "建成四小园个数",
          total: "135558",
          unit: "个",
          iconPath: require("@/assets/images/granary/nc/zrcs-icon.png")
        }
        // {
        //   name: "路面硬化",
        //   total: "1952",
        //   unit: "公里",
        //   iconPath: require("@/assets/images/granary/nc/lmyh-icon.png")
        // },
        // {
        //   name: "集中供水",
        //   total: "3641",
        //   unit: "户",
        //   iconPath: require("@/assets/images/granary/nc/jzgs-icon.png")
        // },
        // {
        //   name: "垃圾收集点",
        //   total: "492",
        //   unit: "个",
        //   iconPath: require("@/assets/images/granary/nc/ljsjd-icon.png")
        // },
        // {
        //   name: "雨污分流",
        //   total: "1471",
        //   unit: "公里",
        //   iconPath: require("@/assets/images/granary/nc/ywfl-icon.png")
        // }
      ],
      rankingList: [],
      activeIndex: 0
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      get("/api/dp/visual/queryList?code=zzjz").then(res => {
        const { item, data } = res;
        if (Array.isArray(data) && data.length > 0) {
          const _dt = data[0];
          this.list.map(e => {
            const index = findIndexByName(e.name, item, "name");
            if (~index) {
              const code = item[index].code;
              e.total = _dt[code];
              e.unit = item[index].unit;
            }
            return e;
          });
        }
      });

      get("/api/dp/visual/getDpDataItemByCode?pagePanelCode=csph").then(res => {
        this.rankingList = res.map((e, i) => {
          const ii = i + 1;
          return {
            city: e.item_name,
            totalNum: Number(e.value),
            unit: e.unit,
            iconPath: require("@/assets/images/granary/nc/icon_" + ii + ".png")
          };
        });
      });
    },
    handleProgressData(val) {
      return val / 10;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.flex
  display flex
.panel
  height calc(65% - 0px)
  width 100%
  .content
    height 100%
    .top-box
      display flex
      flex-wrap wrap
      justify-content space-around
      .top-item
        width 234px
        display flex
        position relative
        margin-top 30px
        .item-left
          width 57px
          height 57px
          display flex
          justify-content center
          align-items center
          background url('~images/granary/nc/b-circle.png') no-repeat
          background-size 100% 100%
          .item-icon
            width 44px
            height 44px
        .right-bot
          width 99px
          height 33px
          line-height 33px
          position absolute
          bottom 2px
          right 19px
          padding-right 8px
          background url('~images/granary/nc/g-title-bg.png') no-repeat
          background-size 100% 100%
          color #4bf3f9
          cursor pointer
          text-align right
          .item-num
            font-size 24px
            font-family 'electronicFont'
          .item-unit
            font-size 12px
            margin-left 4px
        .right-name
          position absolute
          top -6px
          right 18px
          z-index 100
          font-size 14px
          letter-spacing 1px
        .title-img
          position absolute
          top 5px
          right 23px
          width 82px
          height 10px
      .top-item:hover,.active-item
        .item-left
          background url('~images/granary/nc/y-circle.png')
        .right-bot
          color #f5bc02
  .top-item:nth-child(5)
    .right-name
      right 2px !important
  .area-title
    text-align center
    color #89b4e5
    font-size 18px
    letter-spacing 1px
    line-height 26px
    border-bottom 1px solid #89b4e5
    margin 45px 0 20px
  .ranking-item
    width calc(100% - 30px)
    margin 16px auto
    justify-content space-between
    align-items center
    .ranking-left img
      width 19px
      height 23px
      margin-top 8px
    .ranking-right
      width calc(100% - 26px)
      .ranking-right-top
        justify-content space-between
        margin-bottom 2px
      .city-name
        font-size 14px
        color #4bf3f9
      .num-box
        font-size 24px
        font-family 'electronicFont'
        color #f3bb02
        // margin-right 8px
      .ranking-unit
        font-size 14px
        color #7893af
>>>.el-progress-bar__outer
  background #0f3f76
>>>.el-progress-bar__inner
  background linear-gradient(to right,#1b9aff,#05f1ff)
</style>
